module.exports = __webpack_public_path__ + "static/media/29_tn.2872351b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/thumbnails/29_tn.jpg
// module id = 338
// module chunks = 0